<script>
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import {mapGetters} from "vuex";

window.Pusher = Pusher;

export default {
  name: "ConnectionStatus",
  data() {
    return {
      connectionStatus: 'connecting',
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters({
      User: "StateUser",
      ActiveConversationId: "StateActiveConversationId"
    }),
  },
  methods: {
    updateConnectionStatus(state) {
      this.connectionStatus = state;
    // },
    // reload(){
    //   window.location.reload()
    }
  },
  beforeUnmount() {
    if(this.User) {
      this.User.specialist.specialties_info.map(function (specialty) {
        window.Echo.leaveChannel('specialty_queue.' + specialty.id);
      })
      window.Echo.leaveChannel('user.notifications.' + this.User.id)
    }
  },
  mounted() {
    window.Echo = new Echo({
      broadcaster: 'reverb',
      key: process.env.VUE_APP_PUBLIC_REVERB_APP_KEY,
      wsHost: process.env.VUE_APP_PUBLIC_REVERB_HOST,
      wsPort: process.env.VUE_APP_PUBLIC_REVERB_PORT,
      wssPort: process.env.VUE_APP_PUBLIC_REVERB_PORT,
      forceTLS: (process.env.VUE_APP_PUBLIC_REVERB_SCHEME ?? 'https') === 'https',
      enabledTransports: ['ws', 'wss'],
    });
    window.Echo.connector.pusher.connection.bind('state_change', (status) => {
      this.updateConnectionStatus(status.current)
    })
    if(this.User) {
      this.User.specialist.specialties_info.map(function (specialty) {
        window.Echo.channel('specialty_queue.' + specialty.id).listen("NewProtocolUpdateCreated", function () {
          window.toast.success('Um novo caso entrou na fila.', {
            timeout: null,
            closeOnClick: false
          });
          window.emitter.emit('protocolsReloadProtocolList', {})
        }.bind(this));
      })
      window.Echo.channel('user.notifications.' + this.User.id).listen("MessageSent", (response) => {
        if(this.ActiveConversationId !== response.chat_message_info?.protocol_update_id) {
          window.toast.success('Você tem uma nova mensagem.',{
            timeout: 3000,
            closeOnClick: false
          })
        }
      })
    }
  },
}
</script>

<template>
  <div class="col-12 text-center text-">
    <div v-if="connectionStatus === 'connecting'" class="bg-warning">
      <div>
        <i class="bi bi-hourglass-split"></i>
        Conectando...
      </div>
    </div>

    <div v-if="connectionStatus === 'disconnected'" class="bg-danger-subtle">
      <div class="text-light">
        <i class="bi bi-exclamation-octagon"></i>
        Erro na conexão. Por favor, aguarde…
      </div>
    </div>
    <div v-if="connectionStatus === 'unavailable'" class="bg-danger">
      <div class="text-light">
        <i class="bi bi-x-octagon"></i>
        Erro na conexão. Por favor, aguarde…
        <!-- <button class="btn btn-outline-light btn-sm my-1" @click="reload">Reconectar</button> -->
      </div>
    </div>

    <div v-if="connectionStatus === 'error'" class="error">
      ⚠️ Erro: {{ errorMessage }}
    </div>
  </div>
</template>

<style scoped>

</style>